module.exports = __webpack_public_path__ + "img/UAE.9e58bd70.png";